import { ref } from 'vue';
import { useContacts } from './useContacts.ts';
import { useContactStore } from '@apparatix/stores/useContactStore.ts';

export const useContactDetails = () => {
  const store = useContactStore();
  const { updateContact } = useContacts();

  const saveTimeoutId = ref<number>();

  const saveFieldChange = async (fieldPath: string) => {
    clearTimeout(saveTimeoutId.value);

    saveTimeoutId.value = window.setTimeout(() => sendContactUpdate(fieldPath), 1000);
  };

  const sendContactUpdateSingle = async (fieldPath: string) => {
    if (!store.contactDetails.id) return;
    const [rootField, field] = fieldPath.split('.') as [string, string];

    const updateBody = { id: store.contactDetails.id };

    if (rootField === 'notes') {
      updateBody[rootField] = [store[field]];
    } else if (field === 'phoneNumbers') {
      updateBody['address_phone_numbers'] = store[rootField][field];
    } else if (field === 'emails') {
      updateBody['address_emails'] = store[rootField][field];
    } else if (field === 'webPages') {
      updateBody['address_web_pages'] = store[rootField][field];
    } else if (rootField === 'addresses') {
      updateBody[rootField] = [store[field]];
    } else {
      updateBody[field] = store[rootField][field];
    }

    const payload = { data: { contacts: [updateBody]}};

    updateContact(payload);
  };

  const sendContactUpdate = async (formUpdates) => {
    formUpdates.id = store.contactDetails.id;

    await updateContact({ data: { contacts: [formUpdates]}});
  };

  return { saveFieldChange, sendContactUpdate, sendContactUpdateSingle };
};
